import { FormControlLabel, makeStyles, Switch, Typography } from '@material-ui/core';
import { Fragment, useContext, useEffect, useState } from 'react';
import { defaultGridOptions, useGridColDefs } from '../../utils/GridUtils';
import MaterialTable from 'material-table';
import { AppContext } from '../../contexts/AppContext';

const useStyles = makeStyles(theme => ({
  onlyPendingActive: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  blockedByLoading: props => ({
    pointerEvents: props.blockedByLoading ? 'none' : undefined,
    opacity: props.blockedByLoading ? 0.5 : undefined,
    transition: 'all .5s',
  }),
}));
const PendingBillsGrid = ({ data, loading }) => {
  const sortData = data.sort((a,b)=>{
    return new Date(b.invoiceDate).getTime() - new Date(a.invoiceDate).getTime()
  });
  const classes = useStyles({ blockedByLoading: loading });
  const [onlyPending, setOnlyPending] = useState(false);
  const [rowsToShow, setRowsToShow] = useState([]);
  const { showInfo } = useContext(AppContext);

  useEffect(() => {
    if (onlyPending) {
      const filteredRows = sortData.filter(f => f.invoiceState === 'Demorada');

      if (filteredRows.isEmpty()) {
        showInfo('No hay facturas demoradas');
        setTimeout(() => setOnlyPending(false), 500);
      } else {
        setRowsToShow(filteredRows);
      }
    } else {
      setRowsToShow(sortData);
    }
  }, [onlyPending, sortData]);

  const colDefs = useGridColDefs([
    { title: 'Número de documento', field: 'invoiceNumber' },
    { title: 'Fecha de factura', field: 'invoiceDate', valueType: 'date' },
    { title: 'Tipo de documento', field: 'docType' },
    { title: 'Fecha de vencimiento', field: 'dueDate', valueType: 'date' },
    { title: 'Importe total', field: 'import', currencyRef: 'currency' },
    { title: 'Estado factura', field: 'invoiceState' },
    { title: 'Número de remito', field: 'dispatchCode' },
    { title: 'Nota de ingreso', field: 'entryNote' },
    { title: 'Motivo de demora', field: 'delayReason' },
    { title: 'Fecha de carga', field: 'entryDate', valueType: 'date' },
  ]);

  return (
    <Fragment>
      <div style={{ width: '100%' }}>
        <FormControlLabel
          className={classes.blockedByLoading}
          control={<Switch checked={onlyPending} onChange={() => setOnlyPending(!onlyPending)} name="demorados" color="primary" />}
          label={<Typography className={onlyPending && classes.onlyPendingActive}>Solo demoradas</Typography>}
        />
        <MaterialTable {...defaultGridOptions} columns={colDefs} data={rowsToShow} isLoading={loading} />
      </div>
    </Fragment>
  );
};

export default PendingBillsGrid;
